import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const ClearSuccessDialog = ({ open, setOpen }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    // navigate("/assign-course"); // 🔁 redirect after success
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        Cleared Successfully
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", py: 4 }}>
        <img src="/images/succesfull-check.png" width={60} alt="success" />
        <p style={{ marginTop: 12 }}>
          All assignment data has been cleared.
        </p>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <button className="btn" onClick={handleClose}>
          OK
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ClearSuccessDialog;
